import { render } from "./ProblemSub.vue?vue&type=template&id=72f3e779&scoped=true&ts=true"
import script from "./ProblemSub.vue?vue&type=script&lang=ts"
export * from "./ProblemSub.vue?vue&type=script&lang=ts"

import "./ProblemSub.vue?vue&type=style&index=0&id=72f3e779&lang=less&scoped=true"

import exportComponent from "/drone/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72f3e779"]])

export default __exports__